import { useTranslation } from 'react-i18next';

export default function FeaturesSection() {
  const { t } = useTranslation();

  const otherFeatures = [
    t('other.feature1'),
    t('other.feature2'),
    t('other.feature3')
  ];

  const additionalFeatures = [
    t('other.feature4'),
    t('other.feature5'),
    t('other.feature6')
  ];

  const advantages = [
    t('advantages.feature1'),
    t('advantages.feature2'),
    t('advantages.feature3')
  ];

  const moreAdvantages = [
    t('advantages.feature4'),
    t('advantages.feature5'),
    t('advantages.feature6')
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
              {t('other.title')}
            </h2>
            <ul className="space-y-4">
              {otherFeatures.map((feature, index) => (
                <li key={index} className="flex items-start">
                  <i className="ri-check-line text-blue-600 text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="mt-12">
              <ul className="space-y-4">
                {additionalFeatures.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <i className="ri-check-line text-blue-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {t('advantages.title')}
          </h2>
          <p className="text-xl text-gray-600 mb-12">
            {t('advantages.subtitle')}
          </p>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <ul className="space-y-4">
                {advantages.map((advantage, index) => (
                  <li key={index} className="flex items-start">
                    <i className="ri-check-line text-blue-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">{advantage}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <ul className="space-y-4">
                {moreAdvantages.map((advantage, index) => (
                  <li key={index} className="flex items-start">
                    <i className="ri-check-line text-blue-600 text-xl mr-3 mt-1"></i>
                    <span className="text-gray-700">{advantage}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}